import React from 'react';
import { func, string, bool } from 'prop-types';
import { compose, withStateHandlers } from 'recompose';
import { TwitterPicker } from 'react-color';
import styled from 'styled-components';


const StyledPicker = styled(TwitterPicker)`
  top: 32px;
  right: 11px;
`;

const ColorPickerWrap = styled.div`
  position: absolute;
  z-index: 2;
`;

const PickerFont = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;


const ColorPickerComponent = ({
  onChange, handleClose, handleClick, displayColorPicker, color, className,
}) => (
  <div>
    <div
      className={className}
      onClick={handleClick}
    />
    {
      displayColorPicker &&
      <ColorPickerWrap>
        <PickerFont onClick={handleClose} />
        <StyledPicker
          color={color}
          onChange={onChange}
        />
      </ColorPickerWrap>
    }
  </div>
);

ColorPickerComponent.propTypes = {
  onChange: func.isRequired,
  handleClick: func.isRequired,
  handleClose: func.isRequired,
  color: string.isRequired,
  displayColorPicker: bool.isRequired,
  className: string.isRequired,
};


export const ColorPicker = compose(withStateHandlers(
  ({
    displayColorPicker = false,
    onChange,
  }) => ({
    displayColorPicker,
    onChange,
  }),
  {
    handleClick: ({ displayColorPicker }) => () => ({
      displayColorPicker: !displayColorPicker,
    }),
    handleClose: () => () => ({
      displayColorPicker: false,
    }),
    onChange: props => selectedColor =>
      props.onChange
        ? props.onChange(selectedColor.hex)
        : ({ color: selectedColor.hex }),
  },
))(ColorPickerComponent);



// WEBPACK FOOTER //
// ./src/components/ui-helpers/color-picker.js